export default "__VITE_ASSET__Do0Yusko__"